import React from "react";
import { Box, Typography } from "@mui/material";

import { SECTION } from "@/constants/examConstants";

const isMobileUA = () =>
  /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);

/**
 * The single hidden `<audio>` element used by every exam flow. Renders nothing
 * when the current section is Reading. On mobile we expose the native player
 * until the student has pressed Play once (some mobile browsers block
 * programmatic playback until the first user gesture).
 */
const ExamAudioElement = React.forwardRef(function ExamAudioElement(
  { onPlay, onEnded, currentSection, isPlaying },
  ref
) {
  if (currentSection !== SECTION.LISTENING) return null;
  const isMobile = isMobileUA();
  return (
    <>
      {isMobile && !isPlaying && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: "center" }}
        >
          Please click play to start the exam, this action only need to be done
          once
        </Typography>
      )}
      <Box
        sx={{
          justifyContent: "center",
          display: "flex",
          width: "100%",
          mt: 2,
        }}
      >
        <audio
          ref={ref}
          onPlay={onPlay}
          onEnded={onEnded}
          preload="auto"
          controls={!!isMobile}
          style={
            !isMobile || isPlaying
              ? { display: "none" }
              : { display: "block", width: "50px", height: "40px" }
          }
        />
      </Box>
    </>
  );
});

export default ExamAudioElement;
